import { RootState } from '@/domain/store';

export const selectImpactReferences = (state: RootState) => {
  return state.impactReferences.references;
};
